var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"category"},[_vm._v(_vm._s(_vm.category))])
}
var staticRenderFns = []

export { render, staticRenderFns }